import { MultiSubmissionConfig } from '../types';

export const defaultMultiSubmissionConfig: MultiSubmissionConfig = {
  key: 'competition_default',
  title: 'Submission',
  description: 'Provide the requested links, selections, and files for this competition.',
  submitLabel: 'Submit',
  fields: [
    {
      id: 'project_title',
      type: 'text',
      label: 'Project title',
      required: true,
      placeholder: 'Enter a short project title',
    },
    {
      id: 'primary_link',
      type: 'url',
      label: 'Primary project link',
      required: true,
      placeholder: 'https://example.com',
    },
    {
      id: 'category',
      type: 'select',
      label: 'Category',
      required: true,
      options: [
        { value: 'research', label: 'Research' },
        { value: 'engineering', label: 'Engineering' },
        { value: 'design', label: 'Design' },
      ],
    },
    {
      id: 'supporting_files',
      type: 'file',
      label: 'Supporting files',
      multiple: true,
      helpText: 'Upload any extra files that support your submission.',
    },
    {
      id: 'agreement',
      type: 'checkbox',
      label: 'I confirm this submission is my team’s original work.',
      required: true,
    },
  ],
};
